"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _formatMessage = _interopRequireDefault(require("../format-message"));

require("../rce/languages/de");

/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
var locale = {
  alternative_text_a834dcad: {
    message: "Alternativer Text:"
  },
  announcement_list_da155734: {
    message: "Ank\xFCndigungsliste"
  },
  announcements_a4b8ed4a: {
    message: "Ank\xFCndigungen"
  },
  assignments_1e02582c: {
    message: "Aufgaben"
  },
  background_color_press_down_to_select_ef99fdac: {
    message: "Hintergrundfarbe, zum Ausw\xE4hlen Nach-Unten-Taste dr\xFCcken"
  },
  c_2001_acme_inc_283f7f80: {
    message: "\xA9 2001 Acme Inc."
  },
  cancel_file_upload_9903e7b9: {
    message: "Datei-Upload abbrechen"
  },
  cancel_image_upload_2c771950: {
    message: "Bild-Upload abbrechen"
  },
  cc_attribution_f6de631f: {
    message: "CC Zuordnung"
  },
  cc_attribution_no_derivatives_b006744f: {
    message: "CC Zuordnung, Keine Derivate"
  },
  cc_attribution_non_commercial_39e0d30d: {
    message: "CC Zuordnung, Nicht kommerziell"
  },
  cc_attribution_non_commercial_no_derivatives_9fe74c00: {
    message: "CC Zuordnung, Nicht kommerziell, Keine Derivate"
  },
  cc_attribution_non_commercial_share_alike_c7edb1e5: {
    message: "CC Zuordnung, Nicht kommerziell, zu gleichen Teilen"
  },
  cc_attribution_share_alike_669e7f16: {
    message: "CC Zuordnung, zu gleichen Teilen"
  },
  check_if_the_image_is_decorative_283649b7: {
    message: "Markieren, falls das Bild dekorativ ist"
  },
  choose_usage_rights_33683854: {
    message: "Nutzungsrechte ausw\xE4hlen\xA0...."
  },
  click_any_file_to_insert_a_download_link_for_that__a708fa4c: {
    message: "Um einen Downloadlink f\xFCr eine Datei einzuf\xFCgen, klicken Sie auf die entsprechende Datei."
  },
  click_any_image_to_embed_the_image_in_the_page_2cdd1136: {
    message: "Um ein Bild auf dieser Seite einzuf\xFCgen, klicken Sie auf das entsprechende Bild."
  },
  click_any_page_to_insert_a_link_to_that_page_ac920c02: {
    message: "Um einen Link zu einer Seite einzuf\xFCgen, klicken Sie auf die entsprechende Seite."
  },
  click_to_embed_image_33107dd8: {
    message: "Durch Anklicken Bild einbetten"
  },
  click_to_embed_imagename_c41ea8df: {
    message: "{ imageName } durch Anklicken einbetten"
  },
  click_to_insert_a_link_into_the_editor_c19613aa: {
    message: "Einf\xFCgen eines Links in den Editor"
  },
  click_to_insert_a_link_to_this_item_39794098: {
    message: "Einf\xFCgen eines Links auf dieses Element"
  },
  close_flickr_form_b32e600a: {
    message: "Flickr-Formular schlie\xDFen"
  },
  collaborations_5c56c15f: {
    message: "Kollaborationen"
  },
  copyright_holder_66ee111: {
    message: "Urheberrechtsinhaber:"
  },
  course_navigation_dd035109: {
    message: "Kursnavigation"
  },
  creative_commons_license_725584ae: {
    message: "Creative Commons-Lizenz:"
  },
  decorative_image_fde98579: {
    message: "Dekoratives Bild"
  },
  discussions_a5f96392: {
    message: "Diskussionen"
  },
  discussions_index_6c36ced: {
    message: "Diskussionenindex"
  },
  embed_image_1080badc: {
    message: "Bild einf\xFCgen"
  },
  enter_search_terms_e397b1f0: {
    message: "Suchbegriffe eingeben"
  },
  enter_the_alternative_text_for_this_image_88047c47: {
    message: "Alternativen Text f\xFCr dieses Bild eingeben"
  },
  file_upload_form_4aaad554: {
    message: "Datei hochladen (Formular)"
  },
  files_c300e900: {
    message: "Dateien"
  },
  files_index_af7c662b: {
    message: "Dateienindex"
  },
  folder_705fd2d7: {
    message: "Ordner"
  },
  font_size_press_down_to_select_6c25dc2d: {
    message: "Schriftgr\xF6\xDFe, zum Ausw\xE4hlen Nach-Unten-Taste dr\xFCcken"
  },
  formatting_press_down_to_select_df728c30: {
    message: "Formatierung, zum Ausw\xE4hlen Nach-Unten-Taste dr\xFCcken"
  },
  grades_a61eba0a: {
    message: "Noten"
  },
  group_navigation_99f191a: {
    message: "Gruppennavigation"
  },
  i_have_obtained_permission_to_use_this_file_6386f087: {
    message: "Ich habe die Berechtigung zur Nutzung dieser Datei erhalten."
  },
  i_hold_the_copyright_71ee91b1: {
    message: "Ich bin der Urheberrechtsinhaber"
  },
  if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5: {
    message: "Wenn Sie jetzt keine Nutzungsrechte ausw\xE4hlen, wird diese Datei nach dem Hochladen nicht ver\xF6ffentlicht."
  },
  image_upload_form_7b74079a: {
    message: "Bild hochladen (Formular)"
  },
  images_7ce26570: {
    message: "Bilder"
  },
  insert_equella_links_49a8dacd: {
    message: "Equella-Links einf\xFCgen"
  },
  insert_link_6dc23cae: {
    message: "Link einf\xFCgen"
  },
  insert_math_equation_57c6e767: {
    message: "Math. Gleichung einf\xFCgen"
  },
  link_7262adec: {
    message: "Link"
  },
  link_to_a_new_page_6c4ad034: {
    message: "Link zu einer neuen Seite"
  },
  link_to_other_content_in_the_course_879163b5: {
    message: "Links zu anderen Kursinhalte einf\xFCgen."
  },
  link_to_other_content_in_the_group_3fe25379: {
    message: "Links zu anderen Inhalten der Gruppe einf\xFCgen."
  },
  link_to_url_52dd935c: {
    message: "Link zum URL"
  },
  links_14b70841: {
    message: "Links"
  },
  load_more_results_460f49a9: {
    message: "Weitere Ergebnisse laden"
  },
  loading_25990131: {
    message: "Ladevorgang l\xE4uft..."
  },
  loading_failed_b3524381: {
    message: "Ladevorgang fehlgeschlagen"
  },
  loading_folders_8d4d5d5a: {
    message: "Ordner laden\xA0..."
  },
  modules_c4325335: {
    message: "Module"
  },
  no_results_940393cf: {
    message: "Keine Ergebnisse."
  },
  pages_e5414c2c: {
    message: "Seiten"
  },
  people_b4ebb13c: {
    message: "Personen"
  },
  quizzes_7e598f57: {
    message: "Quizzes"
  },
  record_upload_media_5fdce166: {
    message: "Medien aufzeichnen/hochladen"
  },
  rich_text_area_press_alt_f8_for_help_58f0f2c3: {
    message: "Rich Text-Bereich. F\xFCr Hilfe ALT+F8 dr\xFCcken"
  },
  search_280d00bd: {
    message: "Suchen"
  },
  search_flickr_6884b518: {
    message: "Flickr suchen"
  },
  select_a_file_53ba40ac: {
    message: "W\xE4hlen Sie eine Datei aus."
  },
  select_a_folder_to_upload_your_file_into_b82d12b: {
    message: "W\xE4hlen Sie einen Ordner zum Hochladen Ihrer Datei aus."
  },
  syllabus_f191f65b: {
    message: "Kursplan"
  },
  text_color_press_down_to_select_8f5ad9b5: {
    message: "Textfarbe, zum Auswahlen Nach-Unten-Taste dr\xFCcken"
  },
  the_material_is_in_the_public_domain_279c39a3: {
    message: "Das Material ist gemeinfrei."
  },
  the_material_is_licensed_under_creative_commons_3242cb5e: {
    message: "Das Material ist unter Creative Commons lizenziert."
  },
  the_material_is_subject_to_fair_use_exception_41bc6a4b: {
    message: "Das Material unterliegt den Ausnahmen der fairen Nutzung."
  },
  this_upload_exceeds_the_file_storage_quota_please__c3a1b641: {
    message: "Dieser Upload \xFCberschreitet das Dateispeicherkontingent. Wenden Sie sich an den Systemadministrator."
  },
  upload_8b403d05: {
    message: "Hochladen"
  },
  upload_a_new_file_96e6d4ff: {
    message: "Neue Datei hochladen"
  },
  upload_a_new_image_890df275: {
    message: "Neues Bild hochladen"
  },
  usage_right_ff96f3e2: {
    message: "Nutzungsrecht:"
  },
  what_would_you_like_to_call_the_new_page_d7e4488a: {
    message: "Welchen Namen m\xF6chten Sie der neuen Seite geben?"
  },
  wiki_home_9cd54d0: {
    message: "Wikistartseite"
  }
};

_formatMessage.default.addLocale({
  de: locale
});